<!--商品详情-->
<template>
  <div class="news-content">
    <m-header>
      <div slot="nav"></div>
    </m-header>
    <div class="w">
      <!--产品信息-->
      <div class="item-info gray-box">
        <div class="item-title" v-if="itemTitle">
          {{ itemTitle }}
        </div>
        <div class="item-time" v-if="itemTime">
          {{ itemTime }}
        </div>
        <div class="content">
          <div class="item-content" v-if="itemDetail">
            <div v-html="itemDetail">{{ itemDetail }}</div>
          </div>
          <div class="no-info" v-else>
            <img src="/static/images/no-data.png">
            <br>
            暂无内容数据
          </div>
        </div>
      </div>
    </div>
    <m-footer></m-footer>
    <Customer class="customerSer"></Customer>
  </div>
</template>
<script>
  import details from "/assets/config/schoolList.js";
  import MHeader from '/common/MHeader'
  import MFooter from '/common/MFooter'
  import Customer from '../Order/components/customerSer'
  export default {
    data() {
      return {
        userId: '',
        itemTitle: '',
        itemDetail: '',
        itemTime: ''
      }
    },
    computed: {},
    methods: {
      getNewsDetail(courseId) {
        let result = details[courseId]
        this.itemTitle = result.courseTitle || ''
        this.itemDetail = result.newsDetail || ''
        this.itemTime = result.courseTime || ''
      }
    },
    components: {
      MHeader,
      MFooter,
      Customer
    },
    created() {
      let id = this.$route.query.courseId
      this.getNewsDetail(id)
     document.title = "医小智 - 齿科学院 - 详情"
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .news-content {
    margin: 0 auto;
  }

  .item-info {

    margin: 10px auto 10px;
    padding: 60px;

    .gray-box {
      padding: 0;
      display: block;
    }

    .item-title{
      font-size: 28px;
      color: #424242;
      text-align: center;
      padding-bottom: 20px;
    }

    .item-time{
      font-size: 14px;
      color: #999999;
      text-align: center;
      padding-bottom: 20px;
    }

    .item-content {
      width: 100%;
      text-align: center;
    }
  }

  .no-info {
    padding: 200px 0;
    text-align: center;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// schoolDetail.vue?5173a5b6